import { takeLatest, call, put } from "redux-saga/effects";
import { apiUrl } from "../components/Config/config";
import { GET_UNREADANNOUNCEMENT } from "../actions";
import cookie from "react-cookies";
import Axios from "axios";

export const watchGetUnreadAnnouncement = function*() {
  yield takeLatest(GET_UNREADANNOUNCEMENT, workerGetUnreadAnnouncement);
};

function* workerGetUnreadAnnouncement() {
  const result = yield call(getUnreadAnnouncement);
  yield put({ type: "SET_UNREADANNOUNCEMENT", json: result.data });
}

function getUnreadAnnouncement() {
  const options = {
    headers: { Auth: cookie.load("user_details").token }
  };
  return Axios.get(apiUrl + "announcement/unreadannouncement", options).then(
    response => {
      return response;
    },
    error => {
      return { data: { status: error.response.data.status } };
    }
  );
}
